import Navigation from './Navigation';
import AdminNavigation from './AdminNavigation';
import { cEl } from '../../util';
import { PATH_ADMIN_HOME } from '../path';
import { matchHash } from './Link';
import OptimizeNotice from './OptimizeNotice';

function AppHeader() {
    const header = cEl('header');

    if (matchHash(PATH_ADMIN_HOME)) {
        header.appendChild(AdminNavigation());
    } else {
        OptimizeNotice();
        header.appendChild(Navigation());
    }

    return header;
}

export default AppHeader;
